import Axios from 'axios'

class Configuracoes {
    constructor() {
        this.app = null
        const base = document.querySelector('base')
        this.axios = Axios.create({
            baseURL: `${base.getAttribute('href')}/api`
        })
        // this.app
        // if (this.app)
        //     this.loadConfiguracoes()
    }

    loadConfiguracoes() {
        this.axios
            .get(`configuracoes`)
            .then(response => {
                Object.keys(response.data).forEach(key => this[key] = response.data[key])
                this.app.$eventbus.$emit('loaded-configuracoes')
            })
    }

    get telefoneFormated() {
        if (this.telefone)
            return this.telefone.replace(/\D/gim, '')
        return ''
    }

    get whatsappFormated() {
        if (this.whatsapp)
            return this.whatsapp.replace(/\D/gim, '')
        return ''
    }
    
    get telefoneLink() {
        return `tel:+${this.telefoneFormated}`
    }

    get whatsappLink() {
        return `https://wa.me/${this.whatsappFormated}`
    }

    get emailLink() {
        return `mailto:${this.email_destinatario}`
    }

    install(Vue) {
        Vue.mixin({
			beforeCreate() {
                if (!this.$configuracoes.app) {
					this.$configuracoes.app = this
					setTimeout(() => this.$configuracoes.loadConfiguracoes(), 100)
				}
			},
		})
		Vue.prototype.$configuracoes = new Configuracoes()
	}
}

export default new Configuracoes();